import React from 'react';

interface StreetViewPopupProps {
  lat: number;
  lng: number;
}

export const StreetViewPopup: React.FC<StreetViewPopupProps> = ({ lat, lng }) => {
  return (
    <div className="street-view-popup-container">
      <div className="street-view-popup-header">
        <i className="icon-StreetView"></i>
        <strong>Street View Point</strong>
      </div>
      <div className="street-view-popup-coordinates">
        <div>
          <strong>Latitude:</strong> {lat.toFixed(6)}
        </div>
        <div>
          <strong>Longitude:</strong> {lng.toFixed(6)}
        </div>
      </div>
      <button className="street-view-button">
        <i className="icon-StreetView"></i>
        <span>Open Street View</span>
      </button>
    </div>
  );
};

export default StreetViewPopup;
